import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import VueGradients from '@/components/vue-gradients'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'vue-gradients',
    component: VueGradients
  }, {
    path: '/:type/:colors/:options',
    name: 'vue-gradients-permalink',
    component: VueGradients
  }],
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-17572030-25',
  router
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js